/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  apiUrl: window["env"]["apiUrl"] || "http://150.95.110.131:8085/api",
  mqttUrl: window["env"]["mqttUrl"] || "mqtt://150.95.104.49:8083",
  captcha_siteKey: '6LerXI8qAAAAAIs-SS8TOf3j4nPHl7AJB0UhIhSY',
  login_captcha: window["env"]["login_captcha"] || false
};
